import React from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Grabber from '../svg/Grabber2';
import constants from '../../constants';
import Trash from '../svg/Trash';
import Sermons from '../svg/Sermons';
import Calendar from '../svg/Calendar2';
import Text from '../svg/Text';
import ImageText from '../svg/ImageText';
import Video from '../svg/Video';
import LinkIcon from '../svg/Link';
import Image from '../svg/Image';
import CaptionTooltip from '../common/CaptionTooltip';

export default class SortablePageSectionBlockHolder extends React.Component {
    // Normally you would want to split things out into separate components.
    // But in this example everything is just done in one place for simplicity
    render() {
        return (
            <Droppable droppableId={this.props.type} type="droppableSubItem">
                {(provided) => {
                    return (
                        <div
                            data-qa="content-block-item-holder"
                            ref={provided.innerRef}
                        >
                            {this.props?.contents?.map((item, index) => {
                                let taploc = '';
                                if (item.tapType === 4 && item.tapDestination) { taploc = 'External Link'; }
                                if (item.tapType === 3 && item.tapDestination) { taploc = this.props.forms.filtered?.find((f) => { return f.id === item.tapDestination; })?.name; }
                                if (item.tapType === 2 && item.tapDestination) { taploc = this.props.pages.dropdown?.find((p) => { return p.id === item.tapDestination; })?.name; }
                                if (typeof taploc === 'undefined' || taploc.length < 1) { taploc = 'Error: Invalid Link Found'; }
                                const nextitem = this.props?.contents[index + 1];
                                const ctype = constants.ContentType.find((c) => { return c.Id === item.contentType; });
                                let icon;
                                switch (ctype.Id) {
                                    case 100:
                                        icon = <Calendar />;
                                        break;
                                    case 101:
                                        icon = <Sermons />;
                                        break;
                                    case 103:
                                        icon = <Video color={null} />;
                                        break; 
                                    case 104:
                                        icon = <Text />;
                                        break;
                                    case 105:
                                        icon = <ImageText />;
                                        break;
                                    case 106:
                                        icon = <LinkIcon />;
                                        break;
                                    case 107:
                                        icon = <Image />;
                                        break;
                                    default:
                                        icon = '';
                                }
                                return (
                                    <Draggable key={item.id} draggableId={item.id} index={index} className="content-draggable">
                                        {/* eslint-disable-next-line no-shadow */}
                                        {(provided) => {
                                            return (
                                                <div className={item.contentType !== 102 ? 'content-block-item' : 'content-divider-item content-block-item'}>
                                                    <div style={{ display: 'flex' }} className={item.contentType !== 102 ? '' : 'divider-flex-holder'}>
                                                        { /* eslint-disable */}
                                                        {item.contentType !== 102 &&
                                                        <div className={item.tapDestination ? 'linked content-block-item-inside' : 'content-block-item-inside'}
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                        >
                                                            <span className={`icon ${ctype.Name}`}>
                                                                {icon}
                                                            </span>
                                                            <div className="title-block">
                                                                <span className='block-name'> {ctype.Name}</span>
                                                                {item.tapDestination && <span className='block-link'><FontAwesomeIcon icon={['far', 'link']} /> { taploc } </span>}
                                                            </div>
                                                            <span className='block-grabber'
                                                                {...provided.dragHandleProps}
                                                                style={{
                                                                    display: 'block',
                                                                    margin: '0 10px',
                                                                    height: '40px',
                                                                    width: '100%',
                                                                }}
                                                            >
                                                                <Grabber />
                                                            </span>
                                                            {ctype.Type !== 'module' &&
                                                                <span className="edit-delete-block">
                                                                   <CaptionTooltip tooltipText="Edit">
                                                                        <button data-qa="edit-button" type="button" onClick={() => { this.props.editContentBlock(JSON.parse(JSON.stringify(item))); }}>
                                                                            <FontAwesomeIcon icon={['fas', 'pencil']} color='#616B7D' />
                                                                        </button>
                                                                   </CaptionTooltip>
                                                                   <CaptionTooltip tooltipText="Delete">
                                                                        <button data-qa="delete-button" type="button" onClick={() => { this.props.deleteContentBlock(item.id); }}>
                                                                            <Trash />
                                                                        </button>
                                                                   </CaptionTooltip>
                                                                </span>
                                                            }
                                                        </div>
                                                        }
                                                        {item.contentType === 102 &&
                                                            <div className="content-block-item-inside divider" ref={provided.innerRef} {...provided.draggableProps}>
                                                                <div className='block-grabber divider'
                                                                {...provided.dragHandleProps}
                                                                style={{
                                                                display: 'block',
                                                                margin: '0 10px',
                                                                height: '40px',
                                                                width: '100%',
                                                                }}
                                                                >

                                                                </div>
                                                            <span data-qa="delete-button" onClick={() => { this.props.deleteContentBlock(item.id); }}><FontAwesomeIcon icon={['fas', 'times-circle']} /> Remove line divider</span>
                                                            </div>
                                                        }
                                                        {provided.placeholder}
                                                    </div>
                                                    {nextitem?.contentType !== 102 && item.contentType !== 102 &&
                                                    <div className="divider-holder"><span onClick={() => {
                                                        this.props.addDivider(item.id, this.props.type);
                                                    }}><FontAwesomeIcon icon={['fas', 'plus']} /> Add line divider</span></div>
                                                    }
                                                    {/* eslint-enable */ }
                                                </div>
                                            );
                                        }}
                                    </Draggable>
                                );
                            })}
                            {provided.placeholder}
                        </div>
                    );
                }}
            </Droppable>
        );
    }
}
